/* eslint-disable react-native/no-inline-styles */
import React, {useState, useEffect} from 'react';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import useWebinarApi from '@/Hooks/WebinarApi/useWebinarApi';
import Pagination from '../../Games/Pagination';
import CCLoader from '@/Atoms/CCLoader/CCLoader';
import CCPackageTable, {CustomCell} from '@/Atoms/CCPackageTable';
import CCText from '@/Atoms/CCText';
import Box from '@/Atoms/Box';
import Spacer from '@/Atoms/Spacer';
import {ScrollView, Pressable, Image, Linking} from 'react-native';
import CCColors from '@/Utils/CCColors';
import {FontSizes, vs} from '@/Utils/Dimensions';
import CCButton from '@/Atoms/CCButton/CCButton';
import {CustomInfoBox} from '@/Atoms/InfoIcon';
import Icon from 'react-native-vector-icons/MaterialIcons';
import {TouchableOpacity} from 'react-native-gesture-handler';
import {useNavigation} from '@react-navigation/native';
import {ScreenName} from '@/navigators/StackConstants';
import webinarStore from '@/Screens/Classroom/store/zoomInfoStore';

const tabHeadersWithClassroom = [
  'Webinar topic',
  'Coach',
  'Class Type',
  'Webinar date',
  'Webinar time',
  'Classroom',
  'Webinar URL',
];

const tabHeaders = [
  'Webinar topic',
  'Coach',
  'Class Type',
  'Webinar date',
  'Webinar time',
  'Webinar URL',
];

const Meetings: React.FC<any> = ({userKey}) => {
  const [webinarLoading, setWebinarLoading] = useState(true);
  const [webinarData, setWebinarData] = useState([]);
  const [webinarDetails, setWebinarDetails] = useState([]);
  console.log('webinarDetails: ', webinarDetails);
  const handleOnSuccessWebinarDetails = data => {
    setWebinarData(data.data.webinar_list);
    setWebinarDetails(data.data);
    setWebinarLoading(false);
  };
  const {mutate: getWebinarDetails} = useWebinarApi(
    handleOnSuccessWebinarDetails,
  );
  const [enableClassroom, setEnableClassroom] = useState<boolean>(false);

  useEffect(() => {
    getWebinarDetails({user_key: userKey});
  }, []);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const paginate = (pageNumber: number) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      getWebinarDetails({page: pageNumber, user_key: userKey});
    }
  };
  const {isMobileOrTab} = useMediaQuery();
  const navigation = useNavigation();

  const [tableData, setTableData] = useState<
    Array<
      Array<{
        name: string;
        type: 'text' | 'link' | 'dropdown';
        url?: string;
        options?: string[];
      }>
    >
  >([]);
  useEffect(() => {
    if (webinarData && Array.isArray(webinarData)) {
      const itemsPerPage = 10;
      const totalItems = webinarData.length;

      setTotalPages(Math.ceil(totalItems / itemsPerPage));
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const hasBeginnerClass = webinarData.some(
        item => item?.batch_type === 'Beginner',
      );
      setEnableClassroom(hasBeginnerClass);
      const paginatedData = webinarData.slice(startIndex, endIndex);

      const formattedData = paginatedData.map(item => {
        console.log('game item is .... : ', item);
        const webinar_topic = item?.topic;
        const webinarCoach = item?.coach_name;
        const webinar_date = item?.webinar_date;
        const webinar_time = item?.webinar_time;
        const webinar_url = item?.join_url;
        const meeting_info = item?.meeting_info;
        const webinar_classtype = item?.class_type;
        const webinar_id = item?.webinar_id;
        const registrant_token = item?.registrant_token;
        const meeting_password = item?.meeting_password;
        const occurence_id = item?.occurence_id;
        const meeting_role = item?.meeting_role;
        const is_zoom_meeting = item?.is_zoom_meeting;

        let itemValues: any = [];
        itemValues.push({
          name: isMobileOrTab ? (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <CCText fontSize={FontSizes[15]}>{webinar_topic}</CCText>
            </Box>
          ) : (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <Box
                type="row-flex-start"
                style={{
                  margin: 'auto',
                  width: '100%',
                  flexWrap: 'wrap',
                  // justifyContent: 'row-center',
                }}>
                <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[13]}>
                  {webinar_topic}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        itemValues.push({
          name: isMobileOrTab ? (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <CCText fontSize={FontSizes[15]}>{webinarCoach}</CCText>
            </Box>
          ) : (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <Box
                type="row-flex-start"
                style={{
                  margin: 'auto',
                  width: '100%',
                  flexWrap: 'wrap',
                  // justifyContent: 'row-center',
                }}>
                <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[13]}>
                  {webinarCoach}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        itemValues.push({
          name: isMobileOrTab ? (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <CCText fontSize={FontSizes[15]}>{webinarCoach}</CCText>
            </Box>
          ) : (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <Box
                type="row-flex-start"
                style={{
                  margin: 'auto',
                  width: '100%',
                  flexWrap: 'wrap',
                  // justifyContent: 'row-center',
                }}>
                <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[13]}>
                  {webinar_classtype}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        itemValues.push({
          name: isMobileOrTab ? (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <CCText fontSize={FontSizes[15]}>{webinar_date}</CCText>
            </Box>
          ) : (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <Box
                type="row-flex-start"
                style={{
                  margin: 'auto',
                  width: '100%',
                  flexWrap: 'wrap',
                  // justifyContent: 'row-center',
                }}>
                <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[13]}>
                  {webinar_date}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        itemValues.push({
          name: isMobileOrTab ? (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <CCText fontSize={FontSizes[15]}>{webinar_time}</CCText>
            </Box>
          ) : (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <Box
                type="row-flex-start"
                style={{
                  margin: 'auto',
                  width: '100%',
                  flexWrap: 'wrap',
                  // justifyContent: 'row-center',
                }}>
                <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[13]}>
                  {webinar_time}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        if (
          (item?.batch_type === 'Beginner' ||
            webinar_classtype === 'Beginner') &&
          registrant_token
        ) {
          itemValues.push({
            name: isMobileOrTab ? (
              <Box
                style={{
                  padding: vs(12),
                  width: '100%',
                  height: '100%',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}>
                {webinar_url && (
                  <TouchableOpacity>
                    <CCButton
                      onPress={() => {
                        navigation.navigate(ScreenName.Classroom, {
                          webinarKey: userKey,
                        });
                        // webinarStore[userKey] = webinar.join_url;
                        webinarStore[userKey] = {
                          token: registrant_token,
                          meetingId: webinar_id,
                          password: meeting_password,
                          occurenceId: occurence_id,
                          meetingRole: meeting_role,
                          isZoomMeeting: is_zoom_meeting,
                        };
                      }}>
                      <CCText fontSize={FontSizes[12]}>Join</CCText>
                    </CCButton>
                  </TouchableOpacity>
                )}
              </Box>
            ) : (
              <Box
                style={{
                  padding: vs(12),
                  width: '100%',
                  height: '100%',
                }}>
                <Box
                  type="row-flex-start"
                  style={{
                    margin: 'auto',
                    width: '100%',
                    flexWrap: 'wrap',
                    flexDirection: 'row',
                    alignItems: 'center',
                    // justifyContent: 'row-center',
                  }}>
                  {webinar_url && (
                    <TouchableOpacity>
                      <CCButton
                        onPress={() => {
                          navigation.navigate(ScreenName.Classroom, {
                            webinarKey: userKey,
                          });
                          // webinarStore[userKey] = webinar.join_url;
                          webinarStore[userKey] = {
                            token: registrant_token,
                            meetingId: webinar_id,
                            password: meeting_password,
                            occurenceId: occurence_id,
                            meetingRole: meeting_role,
                            isZoomMeeting: is_zoom_meeting,
                          };
                        }}>
                        <CCText fontSize={FontSizes[12]}>Join</CCText>
                      </CCButton>
                    </TouchableOpacity>
                  )}
                </Box>
              </Box>
            ),
            type: 'link',
          });
        } else {
          itemValues.push({
            name: isMobileOrTab ? (
              <Box
                style={{
                  padding: vs(12),
                  width: '100%',
                  height: '100%',
                }}>
                <CCText fontSize={FontSizes[15]}>Coming Soon</CCText>
              </Box>
            ) : (
              <Box
                style={{
                  padding: vs(12),
                  width: '100%',
                  height: '100%',
                }}>
                <Box
                  type="row-flex-start"
                  style={{
                    margin: 'auto',
                    width: '100%',
                    flexWrap: 'wrap',
                    // justifyContent: 'row-center',
                  }}>
                  <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[13]}>
                    Coming Soon
                  </CCText>
                </Box>
              </Box>
            ),
            type: 'text',
          });
        }
        itemValues.push({
          name: isMobileOrTab ? (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
                flexDirection: 'row',
                alignItems: 'center',
              }}>
              {/* <CustomInfoBox
                text={
                  meeting_info ??
                  'You will get link for meeting on the same date of the meeting'
                }
                customView={
                  <Icon
                    name="info-outline"
                    size={18}
                    style={{marginRight: 6}}
                    color={CCColors.TextColor.Grey}
                  />
                }
              /> */}
              <Pressable
                onPress={() => {
                  window.open(webinar_url, '_blank');
                }}>
                <CCText color={CCColors.Blue} fontSize={FontSizes[15]}>
                  {webinar_url.substring(0, 28) + '...'}
                </CCText>
              </Pressable>
            </Box>
          ) : (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <Box
                type="row-flex-start"
                style={{
                  margin: 'auto',
                  width: '100%',
                  flexWrap: 'wrap',
                  flexDirection: 'row',
                  alignItems: 'center',
                  // justifyContent: 'row-center',
                }}>
                {/* <CustomInfoBox
                  text={
                    meeting_info ??
                    'You will get link for meeting on the same date of the meeting'
                  }
                  customView={
                    <Icon
                      name="info-outline"
                      size={18}
                      style={{marginRight: 6}}
                      color={CCColors.TextColor.Grey}
                    />
                  }
                /> */}
                <Pressable
                  onPress={() => {
                    window.open(webinar_url, '_blank');
                  }}>
                  <CCText color={CCColors.Blue} fontSize={FontSizes[13]}>
                    {webinar_url.substring(0, 18) + '...'}
                  </CCText>
                </Pressable>
              </Box>
            </Box>
          ),
          type: 'link',
        });
        return itemValues;
      });
      setTableData(formattedData || []);
    }
  }, [currentPage, isMobileOrTab, webinarData]);

  const cardData = [
    {
      title: 'Live Classes',
      desc: 'Live IM/GM Classes',
      icon: require('@/Assets/Images/Meetings/Instructor.svg'),
    },
    {
      title: 'Coach',
      desc: 'Personalized training',
      icon: require('@/Assets/Images/Meetings/Coach.svg'),
    },
    {
      title: 'Mentor',
      desc: '1-on-1 Mentor Sessions',
      icon: require('@/Assets/Images/Meetings/Mentor.svg'),
    },
    {
      title: 'Practice',
      desc: 'Learn, compete, & grow',
      icon: require('@/Assets/Images/Meetings/Practice.svg'),
    },
  ];

  return (
    <ScrollView style={{padding: 20}}>
      <Spacer spacing={vs(16)} />
      <Box
        type={isMobileOrTab ? 'center' : 'row-center-between'}
        style={{
          marginLeft: 30,
        }}>
        <CCText fontSize={24} color={CCColors.Primary.Dark}>
          Meetings
        </CCText>
        {isMobileOrTab && <Spacer spacing={10} />}
      </Box>
      <Spacer spacing={vs(20)} />
      {webinarLoading ? (
        <CCLoader loading bgWhite isComponentLoader />
      ) : tableData?.length > 0 ? (
        <Box
          style={{
            backgroundColor: isMobileOrTab ? CCColors.White : '',
            borderRadius: isMobileOrTab ? 8 : 0,
          }}>
          <CCPackageTable
            flexArr={[2, 1.2, 1.2, 1.2, 1.4, 1.2, 2]}
            headers={tabHeadersWithClassroom}
            // flexArr={[2, 1.2, 1.2, 1.2, 1.4, 2]}
            // headers={tabHeaders}
            tableData={tableData}
            isMargin={false}
          />
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            paginate={paginate}
          />
        </Box>
      ) : webinarDetails?.expired === 1 ? (
        <Box style={{alignItems: 'center', padding: 24, gap: 10}}>
          <CCText
            style={{
              fontSize: 24,
              fontWeight: '500',
              lineHeight: 32,
              textAlign: 'center',
            }}>
            {webinarDetails?.display_message}
          </CCText>
          {webinarDetails?.renewal_web_link && (
            <CCButton
              style={{
                paddingHorizontal: 20,
                paddingVertical: 8,
                borderRadius: 32,
              }}
              onPress={() => {
                Linking.openURL(`${webinarDetails?.renewal_web_link}`);
              }}>
              <CCText
                style={{
                  fontSize: 16,
                  fontWeight: '500',
                  lineHeight: 24,
                  color: CCColors?.TextColor?.Dark,
                }}>
                Renew via web
              </CCText>
            </CCButton>
          )}
          {webinarDetails?.renewal_whatsapp_link && (
            <CCButton
              style={{
                paddingHorizontal: 20,
                paddingVertical: 8,
                borderRadius: 32,
              }}
              onPress={() => {
                Linking.openURL(`${webinarDetails?.renewal_whatsapp_link}`);
              }}>
              <CCText
                style={{
                  fontSize: 16,
                  fontWeight: '500',
                  lineHeight: 24,
                  color: CCColors?.TextColor?.Dark,
                }}>
                Renew via whatsapp
              </CCText>
            </CCButton>
          )}
        </Box>
      ) : webinarDetails?.expired === 0 ? (
        <Box style={{alignItems: 'center', padding: 24}}>
          <CCText
            style={{
              fontSize: 24,
              fontWeight: '500',
              lineHeight: 32,
              textAlign: 'center',
            }}>
            Try School of Chess now
          </CCText>
          <CCText
            style={{
              fontSize: 16,
              fontWeight: '400',
              lineHeight: 24,
              textAlign: 'center',
              marginTop: 4,
            }}>
            Home of the world's best coaches, players and the largest
            tournaments.
          </CCText>
          <Box
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: 16,
              marginTop: 32,
            }}>
            {cardData.map((item, index) => (
              <Box
                key={index}
                style={{
                  width: 215,
                  padding: 32,
                  borderRadius: 8,
                  borderWidth: 1,
                  backgroundColor: CCColors?.LightYellow,
                  borderColor: '#DDD8C8',
                }}>
                <Image
                  source={require('@/Assets/Images/Meetings/Pattern.svg')}
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: 90,
                    height: 90,
                  }}
                />
                <Image
                  resizeMode="contain"
                  source={item.icon}
                  style={{height: 44, width: 44, marginBottom: 12}}
                />
                <CCText
                  style={{
                    fontSize: 16,
                    fontWeight: '600',
                    lineHeight: 24,
                  }}>
                  {item.title}
                </CCText>
                <CCText
                  style={{
                    fontSize: 14,
                    fontWeight: '400',
                    lineHeight: 20,
                    marginTop: 4,
                    whiteSpace: 'nowrap',
                  }}>
                  {item.desc}
                </CCText>
              </Box>
            ))}
          </Box>
          <Box style={{marginTop: 32}}>
            <CCButton
              style={{
                paddingHorizontal: 32,
                paddingVertical: 12,
                borderRadius: 32,
              }}
              onPress={() => {
                Linking.openURL(
                  'https://circlechess.com/caissa-school-of-chess/',
                );
              }}>
              <CCText
                style={{
                  fontSize: 16,
                  fontWeight: '500',
                  lineHeight: 24,
                  color: CCColors?.TextColor?.Dark,
                }}>
                Explore Caissa School of Chess
              </CCText>
            </CCButton>
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </ScrollView>
  );
};

export default Meetings;
